<template lang="pug">
    .home(ref="home")
        IntroVideo(:class="{show: screen==='intro_video'}" @next_screen="screen = 'intro_orbits'")
        .orbits(:class="{show: screen==='intro_orbits'}" v-if="periods")
            .periodName(v-if="!isMobileDevice" v-html="activePeriod.name" :class="{hide: hidePeriod}")
            EventsOrbits(v-if="!isMobileDevice"
                :events="activePeriod.events"
                :hideOrbits="hidePeriod")
            PeriodsOrbits(v-if="isMobileDevice"
                :periods="periods"
                @changePeriod="changePeriodMobile")
            //IntroBackground

            IntroLogo(class="inner" :screen="screen" :class="{hide: screen === 'intro_video', none: isMobileDevice && popup != null, up: screen==='intro_video'}")
            IntroParallax(v-if="!isMobileDevice" :stop="popup==='mainPopup'")
            IntroTimeline(v-if="!isMobileDevice" :periods="periods" :activePeriodId="activePeriodId" @changePeriod="changePeriod")
            YearsTimeline(v-if="!isMobileDevice"
                :events="activePeriod.events"
                :hide="hidePeriod")

            transition(name="showMainPopup")
                MainPopup(v-if="popup==='mainPopup'" :eventInfo="eventInfo")

        IntroLogo(class="outer" :screen="screen" :class="{open_popup: popup==='mainPopup', hide: screen === 'intro_orbits', up: screen==='intro_video'}")



        transition(name="showPeriodPopup")
            PeriodPopup(v-if="popup==='periodPopup'"
                :events="activePeriod.events")

        AppCursor
</template>

<script>
    import IntroVideo from '@/components/home/IntroVideo'
    import IntroBackground from '@/components/home/IntroBackground'
    import EventsOrbits from '@/components/home/EventsOrbits'
    import IntroParallax from '@/components/home/IntroParallax'
    import IntroLogo from '@/components/home/IntroLogo'
    import IntroTimeline from '@/components/home/IntroTimeline'
    import YearsTimeline from '@/components/home/YearsTimeline'
    import Cursor from '@/components/elements/Cursor'
    import MainPopup from '@/components/popups/MainPopup'

    import PeriodsOrbits from '@/components/home/PeriodsOrbits'
    import PeriodPopup from '@/components/popups/PeriodPopup'

    export default {
        data: () => ({
            screen: 'intro_video',
            canScroll: true,

            periods: null,

            eventInfo: {},

            activePeriodId: 0, // id Активного периода
            activePeriod: {},
            hidePeriod: false,

        }),
        watch: {
            screen(screen) {
                this.$store.state.whiteHeader = screen === 'intro_video'
            },
            $route(){
                this.checkHash();
            }
        },
        computed: {
            popup() {
                return this.$store.state.popup
            },
            isMobileDevice() {
                return this.$store.state.isMobileDevice;
            }
        },
        methods: {
            changePeriod(id) {
                this.hidePeriod = true;
                setTimeout(() => {
                    this.activePeriodId = id;
                    this.activePeriod = this.periods.find(el => el.id === this.activePeriodId)
                    this.hidePeriod = false;
                }, 500)
            },
            changePeriodMobile(id) {
                this.activePeriodId = id;
                this.activePeriod = this.periods.find(el => el.id === this.activePeriodId)
                this.$store.commit('openPopup', 'periodPopup');
            },
            async showEvent(id) {
                try {
                    let {data} = await this.axios.get('?ACTION=getDetail&ID=' + id);

                    if (data.STATUS === 'ok') {
                        let wordsPopups = [];
                        if (data.DATA.POPUP_LIST) {
                            wordsPopups = Object.entries(data.DATA.POPUP_LIST).map(el => {
                                let [id, content] = el;
                                return {
                                    id: id,
                                    type: content.UF_TYPE,
                                    content: {
                                        link: content.UF_LINK,
                                        name: content.UF_NAME,
                                        text: content.UF_DESCRIPTION,
                                        date: content.UF_DATE,
                                    }
                                }
                            })
                        }
                        this.eventInfo = {
                            date: data.DATA.NAME,
                            title: data.DATA.PREVIEW_TEXT,
                            text: data.DATA.DETAIL_TEXT,
                            slides: data.DATA.SLIDER,
                            wordsPopups: wordsPopups
                        };
                        setTimeout(() => {
                            this.$store.commit('openPopup', 'mainPopup')
                        });
                    }
                } catch (e) {
                    console.log(e);
                }
            },
            preventWheel(e) {
                if (!this.canScroll) return;
                if (e.target.closest('.intro_timeline')) return;
                if (this.popup === 'mainPopup') return
                this.canScroll = false;
                let delta = e.deltaY;

                // scroll down
                if (delta > 0) {
                    this.screen = 'intro_orbits';
                    this.$router.push({path:'/', hash:'history'})
                } else if (delta < 0) {
                    this.screen = 'intro_video';
                    this.$router.push({path:'/'})
                }
                setTimeout(() => {
                    this.canScroll = true
                }, 700);

                /*if (!this.canScroll) {
                    e.preventDefault()
                    return false
                }*/
            },
            async fetchData() {
                try {

                    let {data} = await this.axios.get('?ACTION=getData');
                    if (data.STATUS === 'ok') {

                        this.periods = Object.entries(data.DATA).map(per => {
                            let [ind, el] = per;
                            let splitName = el.NAME.split(' ');

                            let events = el.ELEMENTS.map(ev => ({
                                id: ev.ID,
                                icon: ev.PREVIEW_PICTURE,
                                preview_text: ev.PREVIEW_TEXT,
                                preview_text_short: ev.PREVIEW_TEXT.length > 80 ? ev.PREVIEW_TEXT.slice(0, 80) + '...' : ev.PREVIEW_TEXT,
                                date: ev.EVENT_DATE,
                                year: ev.EVENT_YEAR
                            }));
                            return {
                                id: ind,
                                name: `<span>${splitName[0]}</span> <br> <span>${splitName.slice(1).join(' ')}</span>`,
                                date: el.CODE,
                                events: events

                            }
                        })
                    }
                    this.activePeriod = this.periods.find(el => el.id == this.activePeriodId);
                } catch (e) {
                    console.log(e);
                }
            },
            checkHash(){
                if (this.$route.hash.indexOf('#history') === 0){
                    this.screen = 'intro_orbits';
                    let eventId = this.$route.hash.split('_')[1];
                    if (eventId){
                        setTimeout(()=>{
                            this.showEvent(eventId)
                        },500)
                    }
                }else{
                    this.screen = 'intro_video';
                }
            }
        },
        created() {
            this.fetchData();
            this.checkHash();
        },
        beforeMount() {
            this.$store.state.whiteHeader = true;
        },
        mounted() {
            /*if (!this.isMobileDevice){
                this.$refs.home.addEventListener('wheel', this.preventWheel);
            }*/
        },
        beforeDestroy() {
            /*if (!this.isMobileDevice){
                this.$refs.home.removeEventListener('wheel', this.preventWheel)
            }*/
        },
        components: {
            IntroVideo,

            IntroBackground,
            EventsOrbits,
            IntroParallax,
            IntroLogo,
            IntroTimeline,
            YearsTimeline,
            MainPopup,
            AppCursor: Cursor,

            PeriodsOrbits,
            PeriodPopup,
        },
    }
</script>


<style lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";

    .home{
        cursor: none;
    }

    .intro_video, .orbits {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        will-change: transform;
        transition: transform 0s .7s;

        &.show {
            transform: translateY(0);
            transition: transform .7s ease-in-out;
            z-index: 5;
        }
    }

    .intro_video {
        transform: translate3d(0, -100%, 0);
    }

    .orbits {
        overflow: hidden;
        transform: translate3d(0, 100%, 0);
        background: #fff;
    }


    .intro_background {
        z-index: -10;
    }

    .intro_parallax {
        z-index: -5;
    }

    .periodName {
        position: absolute;
        left: -0.5%;
        bottom: 8.5vh;
        //font-size: to_rem(275px);
        font-size: 14.33vw;
        line-height: 0.81;
        letter-spacing: to_rem(-12px);
        color: rgba(217, 217, 217, 0.251);
        pointer-events: none;
        transition: .5s .5s;

        &.hide {
            opacity: 0;
            transition: .5s;
        }

        span {
            display: inline-block;
            animation: p_name linear infinite;
            animation-direction: alternate;

            &:nth-of-type(1) {
                animation-delay: 0s;
                animation-duration: 55s;
            }

            &:nth-of-type(2) {
                animation-delay: -50s;
                animation-duration: 55s;
            }
        }

        @keyframes p_name {
            from {
                transform: translate3d(0, 0, 0)
            }
            to {
                transform: translate3d(15vw, 0, 0)
            }
        }
    }


    @include razr768_from {
        .showMainPopup-enter {
            .left_side, .right_side {
                opacity: 0;
            }

            .left_side {
                transform: skewX(-28.4deg) translate3d(0, -50%, 0);

                .date {
                    opacity: 0;
                    transform: translateX(-100%);
                }

                .title {
                    opacity: 0;
                }
            }

            .right_side {
                transform: skewX(-28.4deg) translate3d(0, 50%, 0);

                .content {
                    transform: translateY(5%);
                    opacity: 0;
                }
            }
        }

        .showMainPopup-enter-active {
            transition: 1.6s;

            .right_side, .left_side {
                transition: .5s;
            }

            .left_side {
                .title {
                    transition: .6s .9s;
                }

                .date {
                    transition: .5s .5s;
                }
            }

            .right_side .content {
                transition: .5s 1.1s;
            }
        }

        .showMainPopup-leave-active {
            transition: 1s;

            .left_side, .right_side {
                opacity: 0;
                transition: .5s .5s;
            }

            .left_side {
                transform: skewX(-28.4deg) translate3d(0, -50%, 0);

                .title {
                    opacity: 0;
                    transition: .5s .2s;
                }

                .date {
                    opacity: 0;
                    transform: translateX(-100%);
                    transition: .4s .4s;
                }
            }

            .right_side {
                transform: skewX(-28.4deg) translate3d(0, 50%, 0);

                .content {
                    opacity: 0;
                    transition: .4s;
                }
            }
        }
    }

    @include razr767 {
        .showMainPopup-enter {
            opacity: 0;
            transform: translateX(-5%);

            .back {
                transform: translateX(-100%);
            }
        }
        .showMainPopup-enter-active {
            transition: all .8s, opacity .4s, transform .4s;

            .back {
                transition: .4s .2s;
            }
        }
        .showMainPopup-leave-active {
            opacity: 0;
            transition: .5s;
        }
    }

    .showPeriodPopup-enter {
        opacity: 0;

        .back {
            transform: translateX(-100%);
        }

        .list {
            transform: translateX(-5%);
        }
    }

    .showPeriodPopup-enter-active {
        transition: all .8s, opacity .4s;

        .back {
            transition: .4s .2s;
        }

        .list {
            transition: .4s;
        }
    }

    .showPeriodPopup-leave-active {
        opacity: 0;
        transition: .5s;
    }
</style>
